import { Component, inject, OnInit } from '@angular/core';
import { SelfSignupService } from '../../services/self-signup.service';
import {
  ConnectionSelfSignupStatus,
  ConnectionSelfSignupStatusCounts,
} from '../../models/connection-self-signup';
import { takeUntil } from 'rxjs';
import { MenuComponentBase } from '../../../../shared/base-classes/menu-component-base';

@Component({
  selector: 'app-connection-signup-dashboard',
  standalone: true,
  imports: [],
  templateUrl: './connection-signup-dashboard.component.html',
  styleUrl: './connection-signup-dashboard.component.scss',
})
export class ConnectionSignupDashboardComponent
  extends MenuComponentBase
  implements OnInit
{
  selfSignupService = inject(SelfSignupService);

  loading = true;
  // eslint-disable-next-line @typescript-eslint/consistent-generic-constructors
  statusCounts: Map<ConnectionSelfSignupStatus, number> = new Map();

  override ngOnInit(): void {
    super.ngOnInit();
    this.loadStatusCounts();
  }

  loadStatusCounts(): void {
    this.loading = true;
    this.selfSignupService
      .getApplicationStatusCounts()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: ConnectionSelfSignupStatusCounts[]) => {
          response.forEach((item) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const statusKey = this.getStatusEnumFromString(item.status as any);
            if (statusKey !== undefined) {
              this.statusCounts.set(statusKey, item.count);
            }
          });
          this.loading = false;
        },
        error: (error) => {
          console.error('Error loading status counts:', error);
          this.loading = false;
        },
      });
  }

  getStatusEnumFromString(
    status: string,
  ): ConnectionSelfSignupStatus | undefined {
    switch (status) {
      case 'Pending':
        return ConnectionSelfSignupStatus.Pending;
      case 'Approved':
        return ConnectionSelfSignupStatus.Approved;
      case 'Rejected':
        return ConnectionSelfSignupStatus.Rejected;
      case 'Joined':
        return ConnectionSelfSignupStatus.Joined;
      case 'Not Joined':
        return ConnectionSelfSignupStatus.NotJoined;
      default:
        return undefined;
    }
  }

  getCount(status: ConnectionSelfSignupStatus): number {
    return this.statusCounts.get(status) || 0;
  }

  getTotalCount(): number {
    return (
      this.getCount(ConnectionSelfSignupStatus.Pending) +
      this.getCount(ConnectionSelfSignupStatus.Approved) +
      this.getCount(ConnectionSelfSignupStatus.Rejected)
    );
  }

  getConnectionSelfSignupStatus(): typeof ConnectionSelfSignupStatus {
    return ConnectionSelfSignupStatus;
  }
}
